module.exports = __webpack_public_path__ + "static/media/add-section.eb19c5bc.svg";